<div class="fx-column" id="trendChart">
  <div class="fx-row-center-center">
    <form>
      <mat-form-field>
        <mat-select placeholder="Select Lines" [(value)]="selectedLines" multiple>
          <mat-option *ngFor="let l of lines" [value]="l.Line">
            {{ l.Line }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-raised-button color="primary" (click)="changeLines()" type="button"> Submit </button>
    </form>
  </div>
  <div class="fx-row-space-evenly-center" id="options">
    <div class="date-row">
      <app-date-selection (dateChange)="onDateChange($event)"></app-date-selection>
    </div>
  </div>
  
    
 
  <div id="trendChart" *ngIf="showChart" class="chart-main">
    <div echarts [options]="chartOption" class="trend-echart"></div>
  </div>

  <div *ngIf="!showChart" class="no-data">
    <h5>No Data</h5>
  </div>
</div>